export default __webpack_public_path__ + "static/partnerColorIcon17-a81458a237cd2c61e78c9ae52bccca0d.svg";